import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { FC } from 'react';
import { TBasePaper } from './type';

// Extend TBasePaper to include the padding prop
interface TBasePaperWithPadding extends TBasePaper {
  padding?: number;
}

const StyledPaper = styled(Paper)<{ padding?: number }>(({ theme, padding }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(33, 43, 54)' : '#fff',
  ...theme.typography.body2,
  padding: padding === 0 ? '' : theme.spacing(padding || 1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const BasePaper: FC<TBasePaperWithPadding> = ({
  children, sx, className, padding = 1,
}) => (
  <StyledPaper sx={sx} className={className} padding={padding}>
    {children}
  </StyledPaper>
);

export {
  BasePaper,
};
